import styled from 'styled-components';
import GreenDot from '../../../assests/images/greendot.svg';
import YellowDot from '../../../assests/images/yellowdot.svg';

export const OurStoryBanner = styled.section`

    @media screen and (max-width: 1024px){
        padding-top: 100px;
    }
    @media screen and (max-width: 767px){
        padding-top: 90px;
    }

    .search-header{
        display:none;
    }
    .story-tile{
        max-width: inherit;
    }

    .our-story-banner{
        @media screen and (max-width: 1024px){
            padding-top: 90px;
        }
        @media screen and (max-width: 575px){
            padding-top: 80px;
        }
    }
`;

export const OurStorySection = styled.section`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding:50px 0;
     
    @media screen and (max-width: 575px){
        padding: 40px 0;
    }

`;

export const OurStoryImage = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:10px;
    margin-bottom: 50px;
     
    @media screen and (max-width: 575px){
        margin-bottom: 40px;
    }
    img{
        width:100%;
    }
`;
export const StoryGreatNonprofits = styled.div`

`;

export const StoryTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 700;
    line-height: 43px;
    margin-bottom: 15px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`; 

export const StoryText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 20px;
    strong{
        font-weight: 700;
    }
`;

export const StoryImageSection = styled.div`
    position: relative;
    z-index: 1;

    &:after{
        background-image:url(${GreenDot});
        background-size: cover;
        background-position: center;
        position: absolute;
        content: "";
        width: 443px;
        height: 413px;
        background-repeat: no-repeat;
        left: -38px;
        z-index: -1;
        top: -6px;
        transform: rotate(249deg);
        opacity: 0.5;

        @media screen and (max-width: 767px){
            width: 290px;
            height: 290px;
        }
    }
    &:before{
        background-image:url(${YellowDot});
        background-size: cover;
        background-position: center;
        position: absolute;
        content: "";
        width: 443px;
        height: 413px;
        background-repeat: no-repeat;
        right: -51px;
        z-index: -1;
        bottom: 0;

        @media screen and (max-width: 1280px){
            right: 0px;
        }
        
        @media screen and (max-width: 767px){
            width: 290px;
            height: 290px;
        }
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const GreatNonprofitsMission = styled.div`
    padding-top: 75px;

    @media screen and (max-width: 991px){
        padding-top: 50px;
    }
    @media screen and (max-width: 991px){
        padding-top: 40px;
    }

    ${StoryTitle}{
        margin-bottom: 30px;
    }
    .blog_title{
        display:none;
    }
    .card-body{
        span{
            display:none;
        }
    }
`;

export const GreatNonprofitsGreen = styled.div`
    background: #01606F 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding: 12px 89px 12px 12px;
    display:flex;
    gap:20px;
    align-items: center;
    margin:30px 0 50px;
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 27px;
    
    @media screen and (max-width: 991px){
        font-size:18px;
        line-height: 24px;
        margin: 50px 0 50px;
    }

    @media screen and (max-width: 767px){
        margin: 40px 0;
        border-radius: 15px;
    }

    @media screen and (max-width: 575px){
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 10px;
        margin:40px 0;
    }
`;

export const GreatImage = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding:15px 22px;
    img{
        width:100%;
    }
`;

export const GreatGreenText = styled.p`
    margin-bottom: 0px;
`;

export const NonprofitSlider = styled.div`

`;

export const SliderWrapper = styled.div`
    background: #F3F3F3 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding:10px;
    width:100%;
    max-width:588px;
    margin: 0 auto;
`;
export const SliderSwiperItem = styled.div`
    padding:0 95px 12px 95px;
    border-radius: 15px;
    position: relative;
    &:after{
        background: transparent linear-gradient(270deg, #FFFFFF00 0%, #FFFFFFD7 39%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
        width:100%;
        height:100%;
        content:"";
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 15px;
    }
    &:before{
        background: transparent linear-gradient(90deg, #FFFFFF00 0%, #FFFFFFD7 39%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
        width:100%;
        height:100%;
        content:"";
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 15px;
    }
    img{
        width:100%;
    }

    .swiper-pagination-bullet {
        background: #89DCE1;
        width: 10px;
        height: 10px;
    }
    .swiper-pagination-bullet-active {
        background: #33A7AE;
        width: 16px;
        height: 16px;
    }
`;

export const SliderTitle = styled.h3`
     color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    margin:0 auto 30px auto;
    text-align: center;
    max-width:916px;
    width:100%;
`;

export const SliderItemTitle = styled.h4`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 40px;
    margin-top: 15px;
    text-align: center;

    @media screen and (max-width: 575px){
        font-size: 18px;
        line-height: 24px;
    }
`;

export const NonprofitOrganization = styled.div`
    margin-top: 30px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    
    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 22px;
    }

    strong{
        color: #01606F;
        font-weight: 700;
    }
`;

export const OrganizationText = styled.p`
    margin-bottom: 20px;

    &:last-child{
        margin-bottom: 0px;
    }
   
`;